import React, { useState, useEffect } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    unableToFind: "Sorry, I can't find what you're looking for.",
    searchResult: "Here is the search result for ",
    results: "Here are all the search results:",
    cannotFind: "Cannot find the answer you are looking for?",
    question1: "How do I reset my password ?",
    question2: "How do I cancel my subscription plan ?",
    question3: "Can I remotely disable access of a lock for a specific user ?",
    question4: "How do I add a new smart lock to my account ?",
    question5: "How do I grant temporary access to someone else ?",
    question6: "Can I track the history of lock/unlock events ?",
    question7:
      "What security measures are in place to protect my smart lock from hacking ?",
    question8:
      "How do I revoke access of a lock for a user who no longer needs it ?",
    question9:
      "What type of battery does the smart lock use, and how long does it typically last ?",
    question10: "How can I add or remove a member from my account ?",
    question11:
      "Is there a mobile app in addition to the web portal for managing the smart lock ?",
    question12:
      "How do I customise the settings and preferences for my smart lock ?",
    question13:
      "Can I set up one-time access for locks for guests or delivery personnel ?",
    question14:
      "Is there a way to make the smart lock work with a physical key as a backup ?",
    question15:
      "Can I use the smart lock with multiple smartphones or devices simultaneously ?",
    question16: "What are recipients for in the user management page ?",
    question17:
      "Can I assign different names or labels to each smart lock for easy identification ?",
    question18:
      "How do I change the primary administrator or owner of the smart lock ?",
    question19: "How do I remove a smart lock from my account ?",
    question20: "Where can I find help or support resources on the website ?",
    question21:
      "How do I change my account settings, such as email address or notification preferences ?",
    question22: "What is multi-approval, and how does it relate to the lock ?",
    question23:
      "Is there a way to export my access history data to a spreadsheet from the website ?",
    question24: "How do I change the language on the website ?",
    question25: "How does multi-approval enhance the security of the lock ?",
    question26:
      "What happens to the functionality of the smart lock if it loses power or the battery dies ?",
    question27:
      "How does the smart lock handle firmware updates and security patches ?",
    question28:
      "What type of support and warranty is provided for the smart lock ?",
    question29:
      "How do I switch my subscription plan to another subscription plan on the website ?",
    question30: "Instruction on the website",
    question31: "What are the advantage of eGeeTouch Smartlock ?",
    question32:
      "How do eGeeTouch NFC Smartlock differ from other Bluetooth Padlocks ?",
    question33: "How secure is eGeeTouch NFC smart luggage lock ?",
    question34:
      "How does eGeeTouch Smartlock track missing luggage using Global Positioning System(GPS) ?",
    question35: "What is the battery life for eGeeTouch smart luggage lock ?",
    question36:
      "Does eGeeTouch smart luggage lock provide a rechargeable power pack for charging mobile devices ?",
    question37:
      "Is eGeeTouch NFC luggage lock compliant with TSA requirements ?",
    question38:
      "What models of smartphones or sport bands are compatible with eGeeTouch Smartlock ?",
    question39:
      "What happens if I lose my mobile phone, smart tag, or smart devices ?",
    question40:
      "Is eGeeTouch lock rugged/tough to withstand vandalism , tampering , lock-picking , damage , or bumping ?",
    question41:
      "Can a person simply damage zippers (e.g., using a pen/knife) to access contents of a luggage ?",
    question42: "Is eGeeTouch smart lock waterproof ?",
    question43: "What happen when eGeeTouch Smartlock drops ?",
    question44:
      "How many fobs/tags and smart devices can I pair with my eGeeTouch Smartlock ?",
    question45:
      "What are the available options to unlock these smart electronic locks ?",
    question46:
      "I am a distributor retailer, interested to sell eGeeTouch Smartlocks, how do I go about it ?",
    question47:
      "Can I have my company logo printed on eGeeTouch Smartlock or order in quantity ?",
    question48: "Is eGeeTouch® Smart Electronic Lock patented ?",
    question49: "Why is eGeeTouch a 'smarter' luggage lock ?",
    question50: "Is eGeeTouch luggage lock compliant with TSA requirements ?",
    question51:
      "Has eGeeTouch smart luggage lock been tested as check-in luggage and passed through airport's baggage handling systems ?",
    question52:
      "Are battery used and emission specifications of eGeeTouch Smart luggage locks compliant with safety requirements of FCC, CE, and civil aviation regulatory standards ?",
    question53:
      "What are the Value Propositions of eGeeTouch Smartlocks to Luggage Manufacturer Distributors Retailers ?",
    question54:
      "What are the Unique Selling Points of eGeeTouch Smart Electronic Locks to the Luggage Manufacturer Distributor ?",
    question55: "What is Locklist ?",
    question56: "What is User Management ?",
    question57: "What is Multi Approval ?",
    question58: "What is Retract Access ?",
    question59: "What is Audit Trail ?",
    question60: "What is Plans Subscription ?",
    question61: "What is Grant Access ?",
  },
  ja: {
    unableToFind: "申し訳ありませんが、探しているものが見つかりません。",
    searchResult: "結果: ",
    results: "すべての検索結果は次のとおりです:",
    cannotFind: "探している答えが見つかりませんか？",
    question1: "パスワードをリセットするにはどうすればよいですか？",
    question2:
      "サブスクリプションプランをキャンセルするにはどうすればよいですか？",
    question3:
      "特定のユーザーのロックへのアクセスをリモートで無効にすることはできますか？",
    question4:
      "新しいスマート ロックをアカウントに追加するにはどうすればよいですか？",
    question5: "他の人に一時的なアクセスを許可するにはどうすればよいですか？",
    question6: "ロック/ロック解除イベントの履歴を追跡できますか？",
    question7:
      "スマート ロックをハッキングから守るためにどのようなセキュリティ対策が講じられていますか？",
    question8:
      "ロックが必要なくなったユーザーのロックへのアクセスを取り消すにはどうすればよいですか？",
    question9:
      "スマート ロックはどのような種類のバッテリーを使用しますか? また、通常どのくらい持続しますか？",
    question10:
      "アカウントにメンバーを追加または削除するにはどうすればよいですか？",
    question11:
      "スマート ロックを管理するための Web ポータル以外にモバイル アプリはありますか？",
    question12:
      "スマート ロックの設定と環境設定をカスタマイズするにはどうすればよいですか？",
    question13:
      "ゲストや配達員にロックへのワンタイムアクセスを設定できますか？",
    question14:
      "物理キーをバックアップとして使用してスマートロックを機能させる方法はありますか？",
    question15:
      "スマートロックを複数のスマートフォンやデバイスで同時に使用できますか？",
    question16: "ユーザー管理ページの受信者とは何ですか？",
    question17:
      "簡単に識別できるように、各スマート ロックに異なる名前やラベルを割り当てることはできますか？",
    question18:
      "スマート ロックの主管理者または所有者を変更するにはどうすればよいですか？",
    question19:
      "アカウントからスマート ロックを削除するにはどうすればよいですか？",
    question20:
      "Web サイトのどこでヘルプやサポート リソースを見つけることができますか？",
    question21:
      "電子メール アドレスや通知設定などのアカウント設定を変更するにはどうすればよいですか？",
    question22: "複数承認とは何ですか? ロックとどのように関係しますか？",
    question23:
      "ウェブサイトからアクセス履歴データをスプレッドシートにエクスポートする方法はありますか？",
    question24: "Web サイトの言語を変更するにはどうすればよいですか？",
    question25: "複数承認はロックのセキュリティをどのように強化しますか？",
    question26:
      "スマートロックの電源が切れたり、バッテリーが切れたりした場合、スマートロックの機能はどうなりますか？",
    question27:
      "スマート ロックはファームウェアのアップデートとセキュリティ パッチをどのように処理しますか？",
    question28: "スマートロックにはどのようなサポートや保証が提供されますか？",
    question29:
      "Web サイトで自分のサブスクリプション プランを別のサブスクリプション プランに切り替えるにはどうすればよいですか？",
    question30: "ウェブサイトでの説明",
    question31: "eGeeTouch スマートロックの利点は何ですか？",
    question32:
      "eGeeTouch NFC スマートロックは他の Bluetooth 南京錠とどう違うのですか？",
    question33: "eGeeTouch NFC スマート ラゲッジ ロックはどの程度安全ですか？",
    question34:
      "eGeeTouch スマート ロックは全地球測位システム (GPS) を使用して紛失した荷物をどのように追跡しますか？",
    question35:
      "eGeeTouch スマート ラゲッジ ロックのバッテリー寿命はどのくらいですか？",
    question36:
      "eGeeTouch スマート ラゲッジ ロックには、モバイル デバイスを充電するための充電式パワーパックが備わっていますか？",
    question37: "eGeeTouch NFC 荷物ロックは TSA 要件に準拠していますか？",
    question38:
      "eGeeTouch スマート ロックに対応しているスマートフォンやスポーツバンドの機種は何ですか？",
    question39:
      "携帯電話、スマートタグ、またはスマートデバイスを紛失した場合はどうなりますか？",
    question40:
      "eGeeTouch ロックは、破壊行為、改ざん、鍵開け、損傷、衝撃に耐える頑丈/頑丈ですか？",
    question41:
      "人は単にジッパーを損傷するだけで (例: ペンやナイフを使用して) 荷物の中身にアクセスできますか？",
    question42: "eGeeTouch スマート ロックは防水ですか？",
    question43: "eGeeTouch スマート ロックが落下するとどうなりますか？",
    question44:
      "eGeeTouch スマート ロックとペアリングできるフォブ/タグおよびスマート デバイスの数は何ですか？",
    question45:
      "これらのスマート電子ロックのロックを解除するために利用可能なオプションは何ですか？",
    question46:
      "私は代理店小売業者で、eGeeTouch スマート ロックの販売に興味があります。どうすればよいですか？",
    question47:
      "eGeeTouch スマート ロックに会社のロゴを印刷したり、大量に注文したりできますか？",
    question48: "eGeeTouch® スマート電子ロックは特許を取得していますか？",
    question49: "eGeeTouch がなぜ「よりスマートな」荷物ロックなのか？",
    question50: "eGeeTouch 荷物ロックは TSA 要件に準拠していますか？",
    question51:
      "eGeeTouch スマート荷物ロックはチェックイン手荷物としてテストされ、空港の手荷物処理システムを通過しましたか？",
    question52:
      "eGeeTouch スマート ラゲッジ ロックの使用バッテリーと排出仕様は、FCC、CE、および民間航空規制基準の安全要件に準拠していますか？",
    question53:
      "eGeeTouch スマートロックの荷物製造業者、販売業者、小売業者への価値提案は何ですか？",
    question54:
      "荷物の製造販売業者に対する eGeeTouch スマート電子ロックのユニークなセールス ポイントは何ですか？",
    question55: "ロックリストとは何ですか？",
    question56: "ユーザー管理とは何ですか？",
    question57: "複数承認とは何ですか？",
    question58: "リトラクトアクセスとは何ですか？",
    question59: "監査証跡とは何ですか？",
    question60: "プランのサブスクリプションとは何ですか？",
    question61: "アクセス許可とは何ですか？",
  },
  es: {
    unableToFind: "Lo siento, no puedo encontrar lo que estás buscando.",
    searchResult: "Aquí está el resultado de la búsqueda de ",
    results: "Aquí están todos los resultados de la búsqueda:",
    cannotFind: "¿No encuentras la respuesta que buscas?",
    question1: "¿Cómo restablezco mi contraseña?",
    question2: "¿Cómo cancelo mi plan de suscripción?",
    question3:
      "¿Puedo desactivar remotamente el acceso a una candado para un usuario específico?",
    question4: "¿Cómo agrego una nueva candado inteligente a mi cuenta?",
    question5: "¿Cómo concedo acceso temporal a otra persona?",
    question6:
      "¿Puedo realizar un seguimiento del historial de eventos de bloqueo/desbloqueo?",
    question7:
      "¿Qué medidas de seguridad existen para proteger mi candado inteligente contra piratería?",
    question8:
      "¿Cómo revoco el acceso a un candado para un usuario que ya no lo necesita?",
    question9:
      "¿Qué tipo de batería utiliza la candado inteligente y cuánto dura normalmente?",
    question10: "¿Cómo puedo agregar o eliminar un miembro de mi cuenta?",
    question11:
      "¿Existe una aplicación móvil además del portal web para gestionar la candado inteligente?",
    question12:
      "¿Cómo personalizo la configuración y preferencias de mi candado inteligente?",
    question13:
      "¿Puedo configurar un acceso único a las candados para invitados o personal de entrega?",
    question14:
      "¿Hay alguna manera de hacer que la candado inteligente funcione con una llave física como respaldo?",
    question15:
      "¿Puedo usar la candado inteligente con varios teléfonos inteligentes o dispositivos simultáneamente?",
    question16:
      "¿Para qué sirven los destinatarios en la página de gestión de usuarios?",
    question17:
      "¿Puedo asignar diferentes nombres o etiquetas a cada candado inteligente para una fácil identificación?",
    question18:
      "¿Cómo cambio el administrador principal o el propietario de la candado inteligente?",
    question19: "¿Cómo elimino una candado inteligente de mi cuenta?",
    question20:
      "¿Dónde puedo encontrar ayuda o recursos de soporte en el sitio web?",
    question21:
      "¿Cómo cambio la configuración de mi cuenta, como la dirección de correo electrónico o las preferencias de notificación?",
    question22:
      "¿Qué es la aprobación múltiple y cómo se relaciona con la candado?",
    question23:
      "¿Existe alguna manera de exportar los datos de mi historial de acceso a una hoja de cálculo desde el sitio web?",
    question24: "¿Cómo cambio el idioma en el sitio web?",
    question25:
      "¿Cómo mejora la aprobación múltiple la seguridad de la candado?",
    question26:
      "¿Qué sucede con la funcionalidad de la candado inteligente si se queda sin energía o se agota la batería?",
    question27:
      "¿Cómo maneja la candado inteligente las actualizaciones de firmware y los parches de seguridad?",
    question28:
      "¿Qué tipo de soporte y garantía se proporciona para la candado inteligente?",
    question29:
      "¿Cómo cambio mi plan de suscripción a otro plan de suscripción en el sitio web?",
    question30: "Instrucciones en el sitio web.",
    question31: "¿Cuáles son las ventajas de eGeeTouch candado inteligente?",
    question32:
      "¿En qué se diferencia eGeeTouch NFC candado inteligente de otros candados Bluetooth?",
    question33:
      "¿Qué tan seguro es el candado de equipaje inteligente eGeeTouch NFC?",
    question34:
      "¿Cómo rastrea eGeeTouch candado inteligente el equipaje perdido mediante el sistema de posicionamiento global (GPS)?",
    question35:
      "¿Cuál es la duración de la batería del candado de equipaje inteligente eGeeTouch?",
    question36:
      "¿El candado de equipaje inteligente eGeeTouch proporciona una fuente de alimentación recargable para cargar dispositivos móviles?",
    question37:
      "¿El candado de equipaje eGeeTouch NFC cumple con los requisitos de la TSA?",
    question38:
      "¿Qué modelos de teléfonos inteligentes o correas deportivas son compatibles con eGeeTouch candado inteligente?",
    question39:
      "¿Qué sucede si pierdo mi teléfono móvil, mi etiqueta inteligente o mis dispositivos inteligentes?",
    question40:
      "¿La candado eGeeTouch es robusta/resistente para soportar vandalismo, manipulación, forzamiento, daños o golpes?",
    question41:
      "¿Puede una persona simplemente dañar las cremalleras (por ejemplo, usando un bolígrafo o un cuchillo) para acceder al contenido de un equipaje?",
    question42: "¿La candado inteligente eGeeTouch es resistente al agua?",
    question43: "¿Qué sucede cuando cae eGeeTouch candado inteligente?",
    question44:
      "¿Cuántos llaveros/etiquetas y dispositivos inteligentes puedo emparejar con mi eGeeTouch candado inteligente?",
    question45:
      "¿Cuáles son las opciones disponibles para desbloquear estas candados electrónicas inteligentes?",
    question46:
      "Soy un distribuidor minorista interesado en vender eGeeTouch candados inteligentes, ¿cómo lo hago?",
    question47:
      "¿Puedo imprimir el logotipo de mi empresa en eGeeTouch candado inteligente o realizar un pedido en cantidad?",
    question48:
      "¿Está patentada la candado electrónica inteligente eGeeTouch®?",
    question49:
      '¿Por qué eGeeTouch es un candado para equipaje "más inteligente"?',
    question50:
      "¿El candado para equipaje eGeeTouch cumple con los requisitos de la TSA?",
    question51:
      "¿Se ha probado el candado de equipaje inteligente eGeeTouch como equipaje facturable y ha pasado por los sistemas de manipulación de equipaje del aeropuerto?",
    question52:
      "¿El uso de la batería y las especificaciones de emisiones de los candados de equipaje inteligentes eGeeTouch cumplen con los requisitos de seguridad de la FCC, CE y los estándares regulatorios de aviación civil?",
    question53:
      "¿Cuáles son las propuestas de valor de las candados inteligentes eGeeTouch para los fabricantes, distribuidores y minoristas de equipaje?",
    question54:
      "¿Cuáles son los puntos de venta únicos de las candados electrónicas inteligentes eGeeTouch para el distribuidor del fabricante de equipaje?",
    question55: "¿Qué es la Lista de Candados?",
    question56: "¿Qué es la Gestión de Usuarios?",
    question57: "¿Qué es la Aprobación Múltiple?",
    question58: "¿Qué es la Revocar Acceso?",
    question59: "¿Qué es la Registro de Auditoría?",
    question60: "¿Qué es la Suscripción a Planes?",
    question61: "¿Qué es la Conceder Acceso?",
  },
});

const buttonStyle = {
  border: "none",
  borderRadius: "4px",
  padding: "10px 20px",
  margin: "5px",
  backgroundColor: "#FFC500",
  color: "black",
  cursor: "pointer",
  width: "212.5px",
  height: "auto",
  transition: "background-color 0.3s",
};

const buttonHoverStyle = {
  color: "white",
  backgroundColor: "#EF6C00",
};

const Extract = (props) => {
  const [clicked, setClicked] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [triggered, setTriggered] = useState(false);
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    let languageRef;
    let listener;

    const setupListener = () => {
      const user = auth.currentUser;
      if (user) {
        languageRef = fire
          .database()
          .ref("userSettings")
          .child(user.uid)
          .child("language");

        listener = languageRef.on("value", (snapshot) => {
          const newLanguage = snapshot.val();
          if (newLanguage) {
            localizationStrings.setLanguage(newLanguage);
            setLanguage(newLanguage);
          }
        });
      }
    };

    setupListener();

    return () => {
      if (languageRef && listener) {
        languageRef.off("value", listener);
      }
      setupListener();
    };
  }, []);

  const datalist_of_words2 = [
    //check
    "42",
    "39",
    "21",
    "smart_lock",
    "22",
    "history_lock",
    "27",
    "23",
    "31",
    "45",
    "50",
    "48",
    "53",
    "33",
    "51",
    "36",
    "34",
    "44",
    "54",
    "37",
    "43",
    "25",
    "20",
    "46",
    "26",
    "Q6",
    "29",
    "35",
    "40",
    "instruction_qns",
    "Q1",
    "Q2",
    "Q3",
    "Q4",
    "Q5",
    "Q7",
    "Q9",
    "Q10",
    "Q11",
    "Q12",
    "Q13",
    "Q14",
    "Q15",
    "Q16",
    "Q17",
    "Q18",
    "Q19",
    "Q20",
    "Q21",
    "Q22",
    "Q23",
    "Q25",
    "Q26",
    "Q27",
    "lock",
    "User_Management_comp",
    "MultiApproval",
    "Retract_Access",
    "Audit_Trails",
    "Plan_subscription",
    "GrantAccess",
  ];

  const datalist_of_words3 = [
    localizationStrings.question1,
    localizationStrings.question2,
    localizationStrings.question3,
    localizationStrings.question4,
    localizationStrings.question5,
    localizationStrings.question6,
    localizationStrings.question7,
    localizationStrings.question8,
    localizationStrings.question9,
    localizationStrings.question10,
    localizationStrings.question11,
    localizationStrings.question12,
    localizationStrings.question13,
    localizationStrings.question14,
    localizationStrings.question15,
    localizationStrings.question16,
    localizationStrings.question17,
    localizationStrings.question18,
    localizationStrings.question19,
    localizationStrings.question20,
    localizationStrings.question21,
    localizationStrings.question22,
    localizationStrings.question23,
    localizationStrings.question24,
    localizationStrings.question25,
    localizationStrings.question26,
    localizationStrings.question27,
    localizationStrings.question28,
    localizationStrings.question29,
    localizationStrings.question30,
    localizationStrings.question31,
    localizationStrings.question32,
    localizationStrings.question33,
    localizationStrings.question34,
    localizationStrings.question35,
    localizationStrings.question36,
    localizationStrings.question37,
    localizationStrings.question38,
    localizationStrings.question39,
    localizationStrings.question40,
    localizationStrings.question41,
    localizationStrings.question42,
    localizationStrings.question43,
    localizationStrings.question44,
    localizationStrings.question45,
    localizationStrings.question46,
    localizationStrings.question47,
    localizationStrings.question48,
    localizationStrings.question49,
    localizationStrings.question50,
    localizationStrings.question51,
    localizationStrings.question52,
    localizationStrings.question53,
    localizationStrings.question54,
    localizationStrings.question55,
    localizationStrings.question56,
    localizationStrings.question57,
    localizationStrings.question58,
    localizationStrings.question59,
    localizationStrings.question60,
    localizationStrings.question61,
  ];

  const calculateLevenshteinDistance = (a, b) => {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    const matrix = Array.from(Array(a.length + 1), () =>
      Array(b.length + 1).fill(0)
    );

    for (let i = 0; i <= a.length; i++) {
      matrix[i][0] = i;
    }

    for (let j = 0; j <= b.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
      }
    }

    return matrix[a.length][b.length];
  };

  const stringSimilarity = require("string-similarity");

  const calculateJaroWinklerSimilarity = (word1, word2) => {
    return stringSimilarity.compareTwoStrings(word1, word2);
  };

  const findBestMatch = (dataList, datalist_of_words3) => {
    let bestMatchIndex = -1;
    let minDistance = Infinity;

    for (let i = 0; i < datalist_of_words3.length; i++) {
      const word = datalist_of_words3[i];
      const levenshteinDistance = calculateLevenshteinDistance(
        dataList.join(""),
        word
      );
      const jaroWinklerSimilarity = calculateJaroWinklerSimilarity(
        dataList.join(""),
        word
      );

      const totalScore = levenshteinDistance + (1 - jaroWinklerSimilarity) * 10;

      if (totalScore < minDistance) {
        minDistance = totalScore;
        bestMatchIndex = i;
      }
    }

    return {
      dataListIndex: bestMatchIndex,
      selectedWord: datalist_of_words2[bestMatchIndex],
    };
  };

  const userDataStep = props.steps["type_2"]; //data manipulation
  const data = userDataStep.message.toLowerCase(); //data manipulation
  const dataList = data.split(" "); //data manipulation
  const wordsToRemove = [
    "   ",
    "how",
    "do",
    "i",
    "can",
    "what",
    "is",
    "there",
    "to",
    "on",
    "the",
  ];

  for (let word of wordsToRemove) {
    if (dataList[0].toLowerCase() === word.toLowerCase()) {
      //data manipulation
      dataList.shift(); //data manipulation
    } else {
      break;
    }
  }

  const correctsearchedWords = [];
  const searchedWords = [];
  const searchedWords3 = [];
  const highersnumber = [];

  for (let x = 0; x < datalist_of_words3.length; x++) {
    const data_list2 = datalist_of_words3[x].toLowerCase();
    const wordsToRemove = [
      "   ",
      "how",
      "do",
      "i",
      "can",
      "what",
      "is",
      "there",
      "to",
      "on",
      "the",
    ];
    let data_list3 = data_list2.split(" ");

    for (let word of wordsToRemove) {
      if (data_list3[0].toLowerCase() === word.toLowerCase()) {
        data_list3.shift();
      } else {
        break;
      }
    }

    let counter = 0;
    for (let z = 0; z < data_list3.length; z++) {
      const word = data_list3[z];
      let matchPercentage = 0;

      if (word.length > 5) {
        if (dataList.includes(word.toLowerCase())) {
          //data manipulation
          matchPercentage = 1;
        } else {
          for (let y = 0; y < dataList.length; y++) {
            //data manipulation
            const dataWord = dataList[y].toLowerCase(); //data manipulation
            let counter2 = 0;

            for (let u = 0; u < Math.min(word.length, dataWord.length); u++) {
              //data manipulation
              const currentLetter = word[u];
              const dataLetter = dataWord[u]; //data manipulation
              if (currentLetter === dataLetter) {
                counter2 += 1;
              }
            }

            const wordLength = Math.max(word.length, dataWord.length); //data manipulation
            const currentMatchPercentage = counter2 / wordLength;

            if (currentMatchPercentage > matchPercentage) {
              matchPercentage = currentMatchPercentage;
            }
          }
        }
      } else {
        for (let y = 0; y < dataList.length; y++) {
          //data manipulation
          const dataWord = dataList[y].toLowerCase(); //data manipulation
          let counter2 = 0;

          for (let u = 0; u < Math.min(word.length, dataWord.length); u++) {
            //data manipulation
            const currentLetter = word[u];
            const dataLetter = dataWord[u]; //data manipulation
            if (currentLetter === dataLetter) {
              counter2 += 1;
            }
          }

          const wordLength = Math.max(word.length, dataWord.length); //data manipulation
          const currentMatchPercentage = counter2 / wordLength;

          if (currentMatchPercentage > matchPercentage) {
            matchPercentage = currentMatchPercentage;
          }
        }
      }

      if (word.length > 5) {
        if (matchPercentage === 1) {
          counter += 20;
        } else if (matchPercentage >= 0.9) {
          counter += 5;
        } else if (matchPercentage >= 0.8) {
          counter += 3;
        }
      } else if (word.length > 4) {
        if (matchPercentage >= 0.8) {
          counter += 10;
        } else if (matchPercentage >= 0.6) {
          counter += 5;
        }
      } else if (word.length > 3) {
        if (matchPercentage >= 0.75) {
          counter += 5;
        } else if (matchPercentage >= 0.66) {
          counter += 1;
        }
      } else if (word.length > 2) {
        if (matchPercentage >= 0.66) {
          counter += 5;
        }
      }
    }

    highersnumber.push(counter);
  }

  const numberObjects = highersnumber.map((num, index) => ({
    number: num,
    index,
  }));
  numberObjects.sort((a, b) => b.number - a.number);

  let displayIndices = numberObjects
    .filter((obj) => obj.number > 4)
    .slice(0, 3)
    .map((obj) => obj.index);

  for (let i = 0; i < displayIndices.length; i++) {
    correctsearchedWords.push(dataList[displayIndices[i]]);
    searchedWords.push(datalist_of_words2[displayIndices[i]]);
    searchedWords3.push(datalist_of_words3[displayIndices[i]]);
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Delay for searchedWords to update if initial language is not "en"
      // console.log("Trigger: " + searchedWords);
      if (searchedWords.length === 1 && !triggered) {
        const { dataListIndex, selectedWord } = findBestMatch(
          dataList,
          datalist_of_words3
        );
        props.triggerNextStep({
          value: searchedWords[0],
          trigger: searchedWords[0],
        });
        setSelectedAnswer(searchedWords[0]);
        setTriggered(true);
      } else if (searchedWords.length === 0 && !triggered) {
        props.triggerNextStep({ value: "none_found", trigger: "none_found" });
        setTriggered(true);
      }
    }, [200]);

    return () => clearTimeout(timeoutId);
  }, [dataList, datalist_of_words3, triggered, props]);

  const handleButtonClick = (index) => {
    if (!clicked) {
      const selectedWord = searchedWords[index];
      props.triggerNextStep({ value: selectedWord, trigger: selectedWord });
      setSelectedAnswer(selectedWord);
      setClicked(true);
    }
  };

  const handleButtonClick2 = () => {
    if (!clicked) {
      props.triggerNextStep({ value: "none_found", trigger: "none_found" });
      setClicked(true);
    }
  };

  const options = searchedWords3.map((word, index) => ({
    label: word,
    value: searchedWords[index],
  }));

  if (searchedWords.length === 0) {
    return localizationStrings.unableToFind;
  } else if (searchedWords.length === 1) {
    // console.log("Reply: " + searchedWords);
    return localizationStrings.searchResult + '"' + searchedWords3[0] + '"';
  } else {
    // console.log("Reply: " + searchedWords);
    return (
      <div>
        <div style={{ marginBottom: "6px" }}>{localizationStrings.results}</div>
        <div>
          {options.map((option, index) => (
            <button
              key={index}
              style={{
                ...buttonStyle,
                ...(clicked ? buttonHoverStyle : {}),
              }}
              onClick={() => handleButtonClick(index)}
              disabled={clicked}
            >
              {option.label}
            </button>
          ))}
          <button
            style={{
              ...buttonStyle,
              ...(clicked ? buttonHoverStyle : {}),
            }}
            onClick={handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.cannotFind}
          </button>
        </div>
      </div>
    );
  }
};

export default Extract;
